export var BatchTriggeredBy;
(function (BatchTriggeredBy) {
    BatchTriggeredBy[BatchTriggeredBy["Timer"] = 0] = "Timer";
    BatchTriggeredBy[BatchTriggeredBy["BatchLength"] = 1] = "BatchLength";
    BatchTriggeredBy[BatchTriggeredBy["Flush"] = 2] = "Flush";
    BatchTriggeredBy[BatchTriggeredBy["ActivateLength"] = 3] = "ActivateLength";
    BatchTriggeredBy[BatchTriggeredBy["DirectHit"] = 4] = "DirectHit";
    BatchTriggeredBy[BatchTriggeredBy["DirectActivate"] = 5] = "DirectActivate";
})(BatchTriggeredBy || (BatchTriggeredBy = {}));
